import React from "react";
import className from "classnames/bind";
import { useLanguageStore } from "../../stores/Language/useLanguageStore";
import useTranslations from "../../hooks/useTranslations";
import formatPaymentDate from "../../utils/formatPaymentDate";

/**
 * Component hiển thị thông tin thanh toán
 * @param {Object} props
 * @param {Object} props.paymentInfo - Thông tin thanh toán
 * @param {boolean} props.isPaymentSuccess - Thanh toán thành công
 * @param {boolean} props.isPaymentFailed - Thanh toán thất bại
 * @param {boolean} props.isCODOrder - Đơn hàng COD
 * @param {Object} props.styles - SCSS styles object
 */
const PaymentInfo = ({ 
  paymentInfo, 
  isPaymentSuccess, 
  isPaymentFailed, 
  isCODOrder, 
  styles 
}) => {
  const cx = className.bind(styles);
  const { formatPrice } = useLanguageStore();
  const translations = useTranslations();

  if (!paymentInfo) {
    return <div className={cx("section")}>No payment information available</div>;
  }

  // Lấy tên phương thức thanh toán
  const getPaymentMethodName = (method) => {
    switch (method) {
      case 'cod':
        return 'Cash on Delivery (COD)';
      case 'vnpay':
        return 'VNPay';
      case 'paypal':
        return 'PayPal';
      default:
        return method || 'N/A';
    }
  };

  // Lấy trạng thái thanh toán
  const getPaymentStatusText = () => {
    if (isCODOrder) {
      return translations?.PaymentSuccess?.cod_status || "Cash on Delivery";
    }
    if (isPaymentSuccess) {
      return translations?.PaymentSuccess?.status_success || "Success";
    }
    if (isPaymentFailed) {
      return translations?.PaymentFailed?.status_failed || "Failed";
    }
    return "Processing";
  };

  const getPaymentStatusClass = () => {
    if (isPaymentSuccess || isCODOrder) return "success-status";
    if (isPaymentFailed) return "failed-status";
    return "pending-status";
  };

  return (
    <div className={cx("payment-info")}>
      <div className={cx("section")}>
        <p>
          <strong>{translations?.PaymentSuccess?.payment_status || "Payment Status"}:</strong>{" "}
          <span className={cx(getPaymentStatusClass())}>
            {getPaymentStatusText()}
          </span>
        </p>
        
        <p>
          <strong>{translations?.PaymentSuccess?.amount || "Amount"}:</strong>{" "}
          {formatPrice
            ? formatPrice(paymentInfo.amount || 0)
            : `${parseFloat(paymentInfo.amount || 0).toLocaleString()} ${paymentInfo.currencySymbol || 'VND'}`
          }
        </p>
        
        <p>
          <strong>{translations?.PaymentSuccess?.payment_date || "Payment Date"}:</strong>{" "}
          {formatPaymentDate(paymentInfo.paymentDate)}
        </p>
        
        <p>
          <strong>{translations?.PaymentSuccess?.payment_method || "Payment Method"}:</strong>{" "}
          {getPaymentMethodName(paymentInfo.paymentMethod)}
        </p>
      </div>
    </div>
  );
};

export default PaymentInfo;
